/**
 * @generated SignedSource<<8167904b08133e035b739972790de3cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegisterOrganizationInput = {
  adminUser: UserInput;
  organization: OrganizationInput;
  recaptchaResponse?: string | null;
};
export type UserInput = {
  acceptPrivacyPolicy: boolean;
  acceptTermsAndConditions: boolean;
  acceptedPrivacyPolicyId: string;
  acceptedTermsAndConditionsId: string;
  credential: CredentialInput;
  customFields?: any | null;
  name: string;
};
export type CredentialInput = {
  email: string;
  password: string;
};
export type OrganizationInput = {
  name: string;
};
export type Register_registerOrganization_Mutation$variables = {
  input: RegisterOrganizationInput;
};
export type Register_registerOrganization_Mutation$data = {
  readonly registerOrganization: {
    readonly admin: {
      readonly email: string;
      readonly name: string;
    };
    readonly organization: {
      readonly name: string;
    };
  } | null;
};
export type Register_registerOrganization_Mutation = {
  response: Register_registerOrganization_Mutation$data;
  variables: Register_registerOrganization_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Register_registerOrganization_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterOrganizationPayload",
        "kind": "LinkedField",
        "name": "registerOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "admin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Register_registerOrganization_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterOrganizationPayload",
        "kind": "LinkedField",
        "name": "registerOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "admin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24d587bb9068465330372173ef7dc631",
    "id": null,
    "metadata": {},
    "name": "Register_registerOrganization_Mutation",
    "operationKind": "mutation",
    "text": "mutation Register_registerOrganization_Mutation(\n  $input: RegisterOrganizationInput!\n) {\n  registerOrganization(input: $input) {\n    organization {\n      name\n      id\n    }\n    admin {\n      name\n      email\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "98efbc7f09ed2e2d224a80127b16be30";

export default node;
